// Various date format string constants, to keep any special strings consistent
// across the application
const DATE_FORMATS = {
  Date: "YYYY-MM-DD",
  DateHumanReadable: "ddd, DD MMM",
  Time: "HH:mm",
  TimeHumanReadable: "h:mma",
  DateTime: "YYYY-MM-DDTHH:mm",
  DateTimeHumanReadable: "MMMM Do YYYY, h:mma",
  DateTimeMs: "YYYY-MM-DDTHH:mm:ss.SSS"
};

export default DATE_FORMATS;
